module.exports = __webpack_public_path__ + "static/media/content-edit.5e7c8852.svg";